// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_2Rf","cls2":"VideoResults-cls2_wDb VideoResults-cls1_2Rf"};